import { createContext } from 'react'

const ExchangeOffersViewModeContext = createContext(null)

export default ExchangeOffersViewModeContext
